import React, { useState, useEffect } from 'react'
import { alertActions, regisActions } from '../../../store/actions'
import history from '../../../route/history'
import { connect } from 'react-redux'
import Alert from '../../../module/alert/Alert'
import PolicyTerms from '../PolicyTerms'
import EssentialPrivacy from '../essentialPrivacy'
import OptionalPrivacy from '../optionalPrivacy'

const RegisSimpleComplete = (props) => {
    const [isLink, setIsLink] = useState(false)
    const [userInfo, setUserInfo] = useState()
    const [allCheck, setAllCheck] = useState(false)
    const [showPrivacy, setShowPrivacy] = useState(false)
    const [htmlCode, setHtmlCode] = useState()
    const [title, setTitle] = useState()

    const [state, setState] = useState({
        //checkedJoinFlag: '',
        memberName: props.location.state?.memberName,
        memberId: props.location.state?.memberId,
    })

    useEffect(() => {
        setIsLink(true)
        console.log('연계간편기업회원')

    }, [])

    const goGoogleStore = () => {
        document.location.href = "https://play.google.com/store/apps/details?id=kr.or.utradehub.wallet"
    }
    const goAppStore = () => {
        document.location.href = "https://apps.apple.com/kr/app/%EC%A0%84%EC%9E%90%EB%AC%B8%EC%84%9C%EC%A7%80%EA%B0%91-%EB%94%94%EC%A7%80%ED%84%B8%EB%AC%B8%EC%84%9C-%EC%9C%A0%ED%86%B5/id1643096338"
    }
    return (
        <React.Fragment>
            <div className="wrapper">

                <div className="container">
                    <div className="top_bar">
                        <a href="#" className="anchor"><img src={require('../../../assets/images/sub/ico_back.png')} alt="뒤로가기" /></a>
                    </div>
                    <h3 className="sub_tit">전자문서지갑 회원가입</h3>
                    <div className="sub_stit">
                        <span className="blue">회원가입이 완료되었습니다.</span><br />
                        스토어에서 전자문서지갑 APP을 설치하세요.
                    </div>

                    <p><img src={require('../../../assets/images/sub/join_end_banner.png')} className="img-responsive img-center join_end_banner" alt="" />
                    </p>

                    <div className="man_info_ok">
                        <div className="mio_item">
                            <div className="th">성명</div>
                            <div className="td">{state.memberName}</div>
                        </div>
                        <div className="mio_item">
                            <div className="th">아이디</div>
                            <div className="td">{state.memberId}</div>
                        </div>
                    </div>

                    <div className="ok_form">
                        {/*<div className="of_tit">알림 수신 동의 안내 (선택)</div>*/}
                        {/*<div className="of_txt">전자문서지갑에 성적서 수신 시 알림을 원하는 고객은 알림 정보를 수신 동의하여 주시기 바랍니다.</div>*/}
                        {/*<div className="icheck_wrap mar">*/}
                        {/*    <div className="icheck light mar">*/}
                        {/*        <input type="checkbox" name="z1" id="z1" value="" />*/}
                        {/*            <label htmlFor="z1">E-mail</label>*/}
                        {/*    </div>*/}
                        {/*    <div className="icheck light mar">*/}
                        {/*        <input type="checkbox" name="z2" id="z2" value="" />*/}
                        {/*            <label htmlFor="z2">푸시알림</label>*/}
                        {/*    </div>*/}
                        {/*    <div className="icheck light">*/}
                        {/*        <input type="checkbox" name="z3" id="z3" value="" />*/}
                        {/*            <label htmlFor="z3">SMS</label>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="of_tit">전자문서지갑 APP 다운로드</div>
                        <div className="of_txt">디지털 시험성적서 수신 알림 및 열람을 위해 전자문서지갑을 만나보세요!</div>
                    </div>
                </div>

                <div className="btn_area halfbtn">
                    <div className="half">
                        <button type="button" className="btn btn-blue btn-app google" onClick={goGoogleStore}><span>Google Play</span></button>
                    </div>
                    <div className="half">
                        <button type="button" className="btn btn-blue btn-app apple" onClick={goAppStore}><span>App Store</span></button>
                    </div>
                </div>

            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.regis,
    }
}

const actionCreators = {
    success: alertActions.success,
    error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(RegisSimpleComplete)
